import React from 'react'
import PropTypes from 'prop-types'
import Instance from 'highcharts'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root, Exportable } from './AreaCharts.styles'
import exportToImage from '../../modules/utils/exports'

Instance.setOptions({
  lang: { numericSymbols: ['K', 'M', 'MM', 'KMM'] }
})

/**
 * The AreaChart's component.
 */
const AreaChart = props => {
  const { categories, data, fileName, id, inputBarChartRef, tooltipFormatter, startYear } = props
  const options = {
    accessibility: { enabled: false },
    allowHTML: true,
    chart: { type: 'area' },
    plotOptions: {
      area: {
        stacking: 'normal',
        pointStart: startYear
      }
    },
    series: data,
    title: { text: '' },
    tooltip: {
      shared: true,
      borderWidth: 1,
      formatter: tooltipFormatter,
      shadow: true
    },
    xAxis: {
      categories
    },
    yAxis: {
      gridLineDashStyle: 'ShortDash',
      title: { text: '' }
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'horizontal',
      x: 0,
      y: 0,
      floating: true,
      backgroundColor: 'white',
      borderColor: '#CCC',
      borderWidth: 1,
      shadow: false
    }
  }
  const exportData = () => {
    exportToImage(id, fileName)
  }
  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
        <Exportable onClick={exportData} ref={inputBarChartRef} />
      </Root>
    </>
  )
}

AreaChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.arrayOf(PropTypes.number),
      color: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number),
      month: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      totalAmount: PropTypes.arrayOf(PropTypes.number)
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func.isRequired,
  startYear: PropTypes.arrayOf(PropTypes.number),
  inputBarChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(window.HTMLDivElement) })
  ]),
  fileName: PropTypes.string.isRequired
}

export default AreaChart
